import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import Footer from "../components/Footer";
import lunchHero from "../assets/lunch-hero.jpg";
import logo from "../assets/burgersson-logo.png";


const lunchItems = [
  {
    name: "Bacon & Cheese",
    description:
      "Svenskt nötkött, ost, bacon, karamelliserad lök, senap & ketchup",
  },
  {
    name: "Vegetarisk",
    description:
      "Vegetarisk puck, ost, chilimayo, gurka inlagd i koriander och ingefära, sallad",
  },
  {
    name: "Dagens Burgare",
    description: "Varje lunch kör vi en till burgare från vår meny",
  },
  {
    name: "Shakshuka",
    description:
      "Kryddig tomat och paprikagryta med pocherat ägg, fetaost, koriander. Serveras med smörstekt surdegsbröd",
  },
  {
    name: "Caesar Sallad",
    description:
      "Romansallad, caesardressing, tomat, rödlök, kyckling, bacon, parmesanost & krutonger",
  },
];

const Lunch = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <HeroSection
        image={lunchHero}
        title="Veckans Lunchburgare"
        subtitle="Njut av en riktigt bra burgare till lunch"
        buttons={[{ label: "Takeaway", href: "/takeaway" }]}
      />
      <section
        className="relative py-24 px-6 md:px-16  overflow-hidden"
        style={{ backgroundColor: "#A8ADA9" }}
      >
        {/* Giant watermark logo in background */}
        <div
          className="absolute inset-0 flex items-center justify-center pointer-events-none"
          aria-hidden="true"
        >
          <img
            src={logo}
            alt=""
            className="w-full h-full object-cover opacity-5"
            style={{ filter: "grayscale(100%)" }}
          />
        </div>
        <div className="max-w-4xl mx-auto">
          <h2
            className="font-heading text-2xl md:text-3xl tracking-wide text-[hsl(var(--surface-light-foreground))] uppercase mb-3"
            style={{ lineHeight: "1.3" }}
          >
            Veckans Lunch
          </h2>
          <p className="font-body text-sm text-[hsl(var(--surface-light-foreground)/.7)] uppercase tracking-wide mb-4">
            Tisdag - Fredag 11:30 - 14:00
          </p>
          <p className="font-body text-sm text-[hsl(var(--surface-light-foreground)/.7)] mb-14">
            Det går även bra att beställa mat via vår hemsida eller Foodora
            under lunchtid.
          </p>
          <div className="max-w-2xl mx-auto flex flex-col gap-8">
            {lunchItems.map((item) => (
              <div key={item.name}>
                <h3 className="font-heading text-base tracking-wide text-[hsl(var(--surface-light-foreground))] uppercase mb-1.5 leading-[1.2]">
                  {item.name}
                </h3>
                <p className="font-body text-xs text-[hsl(var(--surface-light-foreground)/.6)] uppercase tracking-wide leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
          <p className="max-w-2xl mx-auto font-body text-sm text-[hsl(var(--surface-light-foreground)/.7)] uppercase tracking-wide mt-14">
            Burgare med pommes/sallad 120:- (kaffe ingår)
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Lunch;
